
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const BillingTab = () => {
  return (
    <Card className="bg-white shadow-sm border border-gray-200">
      <CardHeader className="pb-4 px-4 lg:px-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Billing & Subscription</h3>
          <p className="text-sm text-gray-600 mt-1">
            Manage your subscription and billing information.
          </p>
        </div>
      </CardHeader>
      <CardContent className="px-4 lg:px-6 space-y-6">
        {/* Current Plan */}
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex justify-between items-start mb-3">
            <div>
              <h4 className="font-semibold text-gray-900">Free Trial</h4>
              <p className="text-sm text-gray-600">Your trial has expired</p>
            </div>
            <Badge variant="outline" className="text-orange-600 border-orange-200">
              Expired
            </Badge>
          </div>
          <Button className="bg-purple-600 hover:bg-purple-700 text-white w-full">
            Upgrade to Pro
          </Button>
        </div>

        {/* Billing History */}
        <div>
          <h4 className="font-semibold text-gray-900 mb-3">Billing History</h4>
          <div className="border rounded-lg">
            <div className="p-4 text-center text-gray-500">
              <p className="text-sm">No billing history available</p>
              <p className="text-xs text-gray-400 mt-1">Upgrade to see your invoices and payment history</p>
            </div>
          </div>
        </div>

        {/* Payment Method */}
        <div>
          <h4 className="font-semibold text-gray-900 mb-3">Payment Method</h4>
          <div className="border rounded-lg p-4">
            <p className="text-sm text-gray-500">No payment method on file</p>
            <Button variant="outline" className="mt-2">
              Add Payment Method
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BillingTab;
